export default __webpack_public_path__ + "static/media/06.f13128fe.jpg";